<template>
  <div class="p-3 custom-bg mt-3">
    <validation-observer ref="addProviderObserver" v-slot="{ validate, reset }">
      <div class="row">
        <div class="col-12 my-3">
          <h5><strong class="fon">Añadir Contratista</strong></h5>
        </div>
        <div class="col-12 my-3">
          <custom-input
            v-if="isValidSsn"
            :disabled="true"
            label="SSN:"
            :value="maskSSN(model.socialSecurityNo)"
          />

          <custom-input
            v-else
            v-model="model.socialSecurityNo"
            mask-type="SSNPatronal"
            placeholder="SSN"
          />
        </div>
        <div class="col-12 mb-3">
          <section-title
            class="section-title__extended mt-4"
            content="Datos de Contratista"
          />
        </div>

        <!-- Fila 1 -->
        <div class="col-12 mb-3">
          <i class="fas fa-info-circle text-orange" />
          <strong class="ml-2">
            Datos del Representante
          </strong>
        </div>

        <div class="col-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.representative"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Nombre:"
            />
          </validation-provider>
        </div>

        <div class="col-1">
          <custom-input
            v-model="model.providerMiddleInitial"
            label="Inicial:"
          />
        </div>

        <div class="col-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.providerPaternalLastName"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Apellido Paterno:"
            />
          </validation-provider>
        </div>

        <div class="col-4">
          <custom-input
            v-model="model.providerMaternalLastName"
            label="Apellido Materno:"
          />
        </div>

        <!-- Fila 2 -->
        <div class="col-12 my-3">
          <i class="fas fa-info-circle text-orange" />
          <strong class="ml-2">
            Datos del Proveedor
          </strong>
        </div>

        <div class="col-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.providerName"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Proveedor:"
            />
          </validation-provider>
        </div>

        <div class="col-4">
          <validation-provider v-slot="{ errors }" rules="required|min:10">
            <custom-input
              v-model="model.phone"
              custom-error-msg="Ingrese un número de teléfono válido."
              :error="errors[0]"
              label="Número de Teléfono:"
              mask-type="Phone"
            />
          </validation-provider>
        </div>

        <div class="col-4">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El campo es requerido.',
              email: 'El correo electrónico no es válido.',
            }"
            rules="required|email"
          >
            <custom-input
              v-model="model.email"
              :error="errors[0]"
              label="Correo Electrónico:"
            />
          </validation-provider>
        </div>

        <!-- Fila 3 -->

        <div class="col-12 my-3">
          <section-title
            class="section-title__extended mt-4"
            content="Datos de Dirección"
          />
        </div>

        <div class="col-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.addressLine1"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Dirección (Línea 1)"
            />
          </validation-provider>
        </div>

        <div class="col-6">
          <custom-input
            v-model="model.addressLine2"
            label="Dirección (Línea 2)"
          />
        </div>

        <div class="col-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="participantType"
              v-model="model.country"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="País"
              :options="countries"
              @input="onCountryChange"
            />
          </ValidationProvider>
        </div>

        <div v-if="isUSA" class="col-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="participantType"
              v-model="model.state"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Estado"
              :options="states"
              @input="onStateChange"
            />
          </ValidationProvider>
        </div>

        <!-- Fila 3 -->
        <div v-if="isPuertoRico" class="col-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="participantType"
              v-model="model.municipality"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio"
              :options="municipalities"
            />
          </ValidationProvider>
        </div>

        <div class="col-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.postalCode"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              label="Código Postal"
              mask-type="ZipcodeExt"
            />
          </ValidationProvider>
        </div>

        <div class="col-12 d-flex justify-content-end my-3">
          <action-button
            class="mr-2 px-3"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger"
            @click="onCancel(reset)"
          />
          <action-button
            class="mr-2 px-3"
            i="fas fa-file-plus"
            text="Añadir"
            variant="success"
            @click="onSubmit(validate, reset)"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//components
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import SectionTitle from 'SectionTitle';

//services
import {
  getStates,
  getCountries,
  getMunicipalities,
} from '@/modules/common/location.api.js';

//utils
const COUNTRY_USA = 63;
const STATE_PUERTO_RICO = 40;

export default {
  name: 'AddProvider',
  components: { ActionButton, CustomInput, CustomDropDown, SectionTitle },
  mixins: [alertMixin],
  props: {
    isReadOnly: { type: Boolean, default: () => false },
    value: { type: String, default: () => '' },
  },

  data() {
    return {
      states: [],
      countries: [],
      municipalities: [],
      model: {
        providerName: '',
        representative: '',
        phone: '',
        email: '',
        addressLine1: '',
        addressLine2: '',
        country: null,
        state: null,
        municipality: null,
        postalCode: '',
        providerMiddleInitial: '',
        providerPaternalLastName: '',
        providerMaternalLastName: '',
        socialSecurityNo: null,
      },
    };
  },
  computed: {
    ssnName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isUSA() {
      return this.model.country?.id === COUNTRY_USA;
    },
    isPuertoRico() {
      return this.model.state?.id === STATE_PUERTO_RICO;
    },
    isValidSsn() {
      const pattern = /^\d{3}-\d{6}$/; // ej: 660-355157
      return pattern.test((this.ssnName || '').trim());
    },
  },
  mounted() {
    this.model.providerName = !this.isValidSsn ? this.ssnName : null;
    this.model.socialSecurityNo = this.isValidSsn ? this.ssnName : null;
    this.loadCatalogs();
  },
  methods: {
    maskSSN(value) {
      if (!value) return '';

      // Elimina espacios y guiones existentes
      let cleanSSN = value.trim().replace(/\D/g, '');

      // Verifica que tenga 9 dígitos
      if (!/^\d{9}$/.test(cleanSSN)) {
        return value; // Si no es válido, retorna el SSN original
      }

      // Obtiene los últimos 4 dígitos
      let last4 = cleanSSN.slice(-4);

      // Devuelve el formato enmascarado
      return `***-**-${last4}`;
    },
    async loadCatalogs() {
      try {
        const [countries, states, municipalities] = await Promise.all([
          getCountries(),
          getStates(),
          getMunicipalities({ academicYearId: 0 }),
        ]);
        this.countries = (countries?.data || countries) ?? [];
        this.states = (states?.data || states) ?? [];
        this.municipalities = (municipalities?.data || municipalities) ?? [];

        const usaIndex = this.countries.findIndex((c) => c.id === COUNTRY_USA);
        if (usaIndex > -1) {
          const usa = this.countries.splice(usaIndex, 1)[0];
          this.countries.unshift(usa);
        }

        const prIndex = this.states.findIndex(
          (s) => s.id === STATE_PUERTO_RICO
        );
        if (prIndex > -1) {
          const pr = this.states.splice(prIndex, 1)[0];
          this.states.unshift(pr);
        }
      } catch (e) {
        this.ShowToast(
          'Catálogos',
          'No fue posible cargar los catálogos.',
          'error'
        );
      }
    },
    onCountryChange() {
      this.model.state = null;
      this.model.municipality = null;
    },
    onStateChange() {
      this.model.municipality = null;
    },
    async onSubmit(validate, reset) {
      const ok = await validate();
      if (!ok) return;

      const fullName = [
        this.model.representative,
        this.model.providerMiddleInitial,
        this.model.providerPaternalLastName,
        this.model.providerMaternalLastName,
      ]
        .map((v) => v?.trim())
        .filter((v) => v);
      const payload = {
        address: this.model.addressLine1,
        email: this.model.email,
        name: this.model.providerName,
        middleInitial: this.model.providerMiddleInitial,
        paternalLastName: this.model.providerPaternalLastName,
        maternalLastName: this.model.providerMaternalLastName,
        phoneNumber: this.model.phone,
        representant: fullName.join(' '),
        countryId: this.model.country?.id || null,
        stateId: this.model.state?.id || null,
        municipalityId: this.model.municipality?.id || null,
        postalCode: this.model.postalCode,
        alternativeAddress: this.model.addressLine2,
        socialSecurityNo: this.model.socialSecurityNo,
      };
      this.$emit('add', payload);
      reset?.();
      this.resetModel();
    },
    onCancel(reset) {
      reset?.();
      this.resetModel();
      this.$emit('cancel');
    },
    resetModel() {
      this.model = {
        providerName: '',
        representative: '',
        phone: '',
        email: '',
        addressLine1: '',
        addressLine2: '',
        country: null,
        state: null,
        municipality: null,
        postalCode: '',
        providerMiddleInitial: '',
        providerPaternalLastName: '',
        providerMaternalLastName: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-bg {
  background-color: #fafafa;
}
</style>
